var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:post"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.82762 32.0925L10.2844 6.81635C10.3679 6.34202 10.544 5.88879 10.8027 5.48253C11.0613 5.07627 11.3975 4.72496 11.792 4.44864C12.1864 4.17233 12.6315 3.97643 13.1017 3.87215C13.5719 3.76786 14.058 3.75723 14.5323 3.84085L36.1986 7.66335C37.1562 7.83235 38.0075 8.37482 38.5652 9.17144C39.1228 9.96805 39.3412 10.9536 39.1723 11.9112L34.7154 37.1874C34.632 37.6617 34.4559 38.1149 34.1972 38.5212C33.9386 38.9274 33.6024 39.2787 33.2079 39.5551C32.8135 39.8314 32.3684 40.0273 31.8982 40.1316C31.428 40.2358 30.9419 40.2465 30.4676 40.1629L8.80128 36.3404C7.84367 36.1714 6.99241 35.6289 6.43474 34.8323C5.87708 34.0357 5.65869 33.0501 5.82762 32.0925Z",
    stroke: "#213867",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8697 11.7002L31.3146 14.2467M15.5956 18.9217L30.0404 21.47M14.3232 26.1432L23.3506 27.7364",
    stroke: "#213867",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.bee08fead427b4617b6f4dc16434a729.svg";
export { ForwardRef as ReactComponent };